{
  "es": {
    "question": {
      "actions": {
        "addDocuments": "Añadir documentos",
        "cancel": "Cancelar",
        "createQuestion": "Crear pregunta",
        "delete": "Eliminar",
        "deleteDocuments": "Eliminar documentos",
        "edit": "Editar",
        "moveDown": "Mover abajo",
        "moveUp": "Mover arriba",
        "new": "Pregunta",
        "save": "Guardar"
      },
      "attributes": {
        "answer": "Respuesta",
        "documents": "Documentos / Imágenes",
        "name": "Pregunta",
        "question": "Pregunta"
      },
      "labels": {
        "editQuestion": "Editar pregunta",
        "newQuestion": "Nueva pregunta"
      },
      "toasts": {
        "create": "Pregunta creada",
        "delete": "Pregunta eliminada",
        "update": "Pregunta actualizada"
      },
      "validation": {
        "needAnswer": "La respuesta es obligatoria",
        "needQuestion": "La pregunta es obligatoria"
      }
    }
  }
}
